export default __webpack_public_path__ + "static/media/ok.2c4c3e11.jpg";